export const JOB_ROUTE_PREFIX = "/settings/jobs";

export const JOB_ROUTE_PATHS = {
  list: { path: "*", to: JOB_ROUTE_PREFIX },
};
